import * as React from 'react';

import { Snackbar } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';

import './style.scss';

interface Props {
  open: boolean;
}

function SnackTokenAlert ({ open }: Props) {

  return (
    <Snackbar
      open={open}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}>
      <React.Fragment>
        <div className='token-invalid-alert'>
          {'Sorry but Token Authorization is Invalid. Trying to refresh it and repeat your request'}
          <br />
          <div className='token-invalid-alert-loader circular-progress-exist-sub-list'>
            <LinearProgress />
          </div>
        </div>
      </React.Fragment>
    </Snackbar>
  );
}

export default React.memo(SnackTokenAlert);
